module.exports = __webpack_public_path__ + "img/9788932907611.488675a7.jpg";